import React, { useState } from "react";
import heartLoading from "../../assests/heartLoading.gif";
import preloader from "../../assests/preloader1.gif";


const BASE_URL = process.env.REACT_APP_API_URL
const Table = ({ tableData = [], pagination = {},  
 onPageChange , errorPreviews = {} ,loading = false}) => {

   const [selectedPreview, setSelectedPreview] = useState("");
   const [isDownloading, setIsDownloading] = useState(false);

   
  const currentPage = pagination?.currentPage ?? 1;
  const pageSize = pagination?.pageSize ?? 10;
  const totalRecords = pagination?.totalRecords ?? (tableData?.length ?? 0);

  const totalPages =
    pagination?.totalPages ?? Math.max(1, Math.ceil(totalRecords / pageSize));

  const indexOfFirstRow = (currentPage - 1) * pageSize + 1;
  const indexOfLastRow = Math.min(currentPage * pageSize, totalRecords);

  const gotoPage = (page) => {
    if (page < 1 || page > totalPages) return;
    onPageChange && onPageChange(page);
  };

   const downloadExcel = (datasetKey) => {
    if (!datasetKey) return;
    setIsDownloading(true);

    const url = `${BASE_URL}/download-url/${encodeURIComponent(datasetKey)}`;

    fetch(url)
      .then((res) => {
        const cd = res.headers.get("content-disposition");
       let filename = datasetKey + ".csv";       
        if (cd) {
          const match = cd.match(/filename="?([^"]+)"?/);
          if (match) filename = match[1];
        }
        return res.blob().then((blob) => ({ blob, filename }));
      })
      .then(({ blob, filename }) => {
        const urlObj = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = urlObj;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(urlObj);
      })
      .catch((err) => console.error("Download failed:", err))
       .finally(() => {
      setIsDownloading(false);   
    });
      
  };

function cleanPipeString(value, option = 'after') {
  if (typeof value !== 'string') return value;

  if (!value.includes('|')) return value;

  switch (option) {
    case 'after':
      return value.split('|')[0]; // Keep before pipe
    case 'before':
      return value.split('|')[1]; // Keep after pipe
    case 'remove':
      return value.replace('|', ' '); // Replace pipe with space
    default:
      return value;
  }
}
  const renderDynamicTable = (rows = [], title) => {
    if (!rows || rows.length === 0) {
      return <p style={{ marginTop: "1rem" }}>No data available for {title}</p>;
    }

const headers = Array.isArray(rows) && rows.length > 0 ? Object.keys(rows[0]) : [];

    return (
   <div style={{ overflowX: "auto", marginTop: "2rem" }}>
  {/* <h3 style={{ marginBottom: "0.5rem", fontWeight: "600" }}>{title}</h3> */}
  <table
    className="rules-table"
    style={{
      minWidth: "100%",           
      borderCollapse: "collapse",
      tableLayout: "auto",        
      whiteSpace: "nowrap"        
    }}
  >
    <thead>
      <tr>
        {headers.map((h) => (
          <th
            key={h}
            style={{
              padding: "14px",
              // borderBottom: "1px solid #ccc",
              textAlign: "left",
              width:"220px",
              whiteSpace: "nowrap" 
            }}
          >
            {h}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows.map((row, idx) => (
        <tr key={idx}>
          {headers.map((h) => (
            <td
              key={h}
              style={{
                padding: "11px",
                // borderBottom: "1px solid #eee",
                whiteSpace: "nowrap",         
                overflow: "hidden",
                              width:"220px",

                textOverflow: "ellipsis",
                verticalAlign: "middle",
              }}
              title={row[h]} 
            >
              {row[h]}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
</div>


    );
  };
  if (loading) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center flex flex-col items-center justify-center space-y-4">
        <img src={preloader} alt="Loading..." width={200} />
        <div className="space-y-2">
                   <span className="text-gray-700 text-[20px]">Hang tight! The resources are loading...</span>

        </div>
      </div>
    </div>
  );
}
    
  return (
    <>
      
<div style={{ overflowX: "auto" }}>
      <table className="rules-table" style={{ marginTop: "2rem" }}>
        <thead>
          <tr>
            <th  className="text-left">Rule ID</th>
            <th  className="text-left">Rule Name</th>
            <th  className="text-left">Rule Phase</th>
            <th  className="text-left">DQ Dimension</th>
            <th  className="text-left">Dataset / Table</th>
            <th  className="text-left">ERROR% VS THRESHOLD%</th>
            <th  className="text-left">Breach Date</th>
            <th className="text-left">Status</th>
            <th  className="text-left">Owner</th>
            <th  className="text-left">Ticket</th>
          </tr>
        </thead>
        <tbody>
          {tableData.length > 0 ? (
            tableData.map((rule, index) => (
              <tr key={index} >
                <td className="text-left align-middle  break-words max-w-[200px]">{rule.ruleId}</td>
                {/* <td className="break-words max-w-[200px] text-left align-middle">{rule.ruleName}</td> */}
                <td className="break-words max-w-[200px] text-left align-middle">
  {rule.ruleName?.includes("|")
    ? rule.ruleName.split("|")[1]?.trim()
    : rule.ruleName}
</td>
                <td className="text-left align-middle">{rule.rulePhase}</td>
<td className="text-left align-middle">
  {rule.dqDimension.charAt(0).toUpperCase() + rule.dqDimension.slice(1)}
</td>           
<td className="text-left align-middle break-words max-w-[200px]">
  {rule.dataAssetName?.includes("|")
    ? rule.dataAssetName.split("|")[1]?.trim()
    : rule.dataAssetName}
</td>                <td className="text-left align-middle">{rule.failPercentageVsThreshold}</td>
                <td className="text-left align-middle">{rule.breachDate}</td>
                <td className="text-left align-middle"
                >
                  {rule.Status}
                </td>
                <td className="text-left align-middle">{rule.ruleOwner}</td>
                <td className="text-left align-middle">{rule.Ticket}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="10" style={{ textAlign: "center", padding: "1rem" }}>
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>

      {/* Example pagination (optional) */}
    {totalRecords > 0 && (
        <div className="pagination mt-4 flex items-center justify-between">
          <span>
            Showing {indexOfFirstRow} to {indexOfLastRow} of {totalRecords} entries
          </span>

          <div className="pagination-controls flex items-center gap-2">
            <button
              disabled={currentPage === 1}
              onClick={() => gotoPage(currentPage - 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              Previous
            </button>

{(() => {
  const pageButtons = [];
  const totalToShow = 5;

  let start = Math.max(1, currentPage - Math.floor(totalToShow / 2));
  let end = start + totalToShow - 1;

  if (end > totalPages) {
    end = totalPages;
    start = Math.max(1, end - totalToShow + 1);
  }

  if (start > 1) pageButtons.push(1);
  if (start > 2) pageButtons.push("...");

  for (let i = start; i <= end; i++) {
    pageButtons.push(i);
  }

  if (end < totalPages - 1) pageButtons.push("...");
  if (end < totalPages) pageButtons.push(totalPages);

  return pageButtons.map((p, idx) =>
    p === "..." ? (
      <span key={idx} className="px-2">...</span>
    ) : (
      <button
        key={idx}
        onClick={() => gotoPage(p)}
        className={`px-3 py-1 border rounded ${
          currentPage === p ? "bg-[#bb1ccc] text-white" : ""
        }`}
      >
        {p}
      </button>
    )
  );
})()}

            <button
              disabled={currentPage === totalPages}
              onClick={() => gotoPage(currentPage + 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "3rem", alignItems: "center" }}>

       <div style={{ display: "flex", gap: "20px", marginTop: "3rem" }}>
        <div className="para">
          <p className="mt-[7px] text-[16px] text-[#3F3F3F]" style={{ fontWeight: "500" }}>
            Select the table you want to view:
          </p>
        </div>
        <div>
          <select
            className="selct-table"
            value={selectedPreview}
            onChange={(e) => setSelectedPreview(e.target.value)}
          >
            <option value="">Select Table</option>
            {Object.keys(errorPreviews || {}).map((key) => (
              <option key={key} value={key}>
                {key}
              </option>
            ))}
          </select>
        </div>
      </div>
     {/* {selectedPreview && (
          <button
            onClick={() => downloadExcel(selectedPreview)}
              disabled={isDownloading}

            style={{
              padding: "9px 15px",
              marginTop:'28px',
              backgroundColor: "#80C6AD",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              
            }}
          >
            {isDownloading ? "Downloading..." : "Download Table"}
          </button>
        )} */}
        {selectedPreview && Array.isArray(errorPreviews[selectedPreview]) && errorPreviews[selectedPreview].length > 0 && (
  <button
    onClick={() => downloadExcel(selectedPreview)}
    disabled={isDownloading}
    style={{
      padding: "9px 15px",
      marginTop: '28px',
      backgroundColor: "#80C6AD",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      opacity: isDownloading ? 0.7 : 1,
    }}
  >
    {isDownloading ? "Downloading..." : "Download Table"}
  </button>
)}

</div>

{selectedPreview && (
  Array.isArray(errorPreviews[selectedPreview])
    ? renderDynamicTable(errorPreviews[selectedPreview], selectedPreview)
    : <p className="mt-[7px] text-red-400 text-center">{errorPreviews[selectedPreview]?.message || "No data available"}</p>
)}    </>
  );
};

export default Table;
